import React from 'react';
import PropTypes from 'prop-types';
import AvatarEditor from '../components/avatar-editor-view';

export class AvatarEditorContainer extends React.Component {
  handleCanvasImage = (canvasImage) => {
    this.props.processImageAndUpload(canvasImage);
  };

  render() {
    return (
      <AvatarEditor
        userImageUrl={this.props.userImageUrl}
        handleCanvasImage={this.handleCanvasImage}
        closeModal={this.props.closeModal}
        showImageSelectorControl={this.props.showImageSelectorControl}
      />
    );
  }
}

AvatarEditorContainer.propTypes = {
  userImageUrl: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  processImageAndUpload: PropTypes.func.isRequired,
  showImageSelectorControl: PropTypes.func.isRequired,
};

export default AvatarEditorContainer;
